module.exports = __webpack_public_path__ + "h5/img/wu.6f09330d.jpeg";